/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Add_PasskeyInputs */



/**
* | output |
* | --- |
* | "Add passkey" |
*
* @param {Partner_Security_Add_PasskeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_add_passkey = /** @type {((inputs?: Partner_Security_Add_PasskeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Add_PasskeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey hinzufügen")
	return /** @type {LocalizedString} */ ("Add passkey")
});